module.exports = __webpack_public_path__ + "static/media/ASID-Design-Excellence-Award-certificate-logo-only.0a564b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ASID-Design-Excellence-Award-certificate-logo-only.jpg
// module id = 451
// module chunks = 0